import { forwardRef, Children, Ref, ReactNode } from 'react';
import classnames from 'classnames';

import { Checkbox } from '@/components/atoms';

type checkboxInputProps = {
  id: string;
  label: ReactNode;
  labelClassName?: string;
  name: string;
  isControlled: boolean;
  disabled: boolean;
  checked: boolean;
  onChange: (event: {
    target: {
      name: string;
      value: string;
      checked: boolean;
    };
  }) => void;
  value: string;
};

const CheckboxInput = forwardRef(function CheckboxInput(
  props: checkboxInputProps,
  ref: Ref<HTMLInputElement>,
) {
  const {
    id,
    label,
    labelClassName,
    name,
    isControlled,
    onChange,
    value,
    ...inputProps
  } = props;

  const defaultLabelClassName = 'checkbox-label space-x-2';
  let defaultCheckboxText = 'checkbox-input-text';

  if (inputProps.disabled) {
    defaultCheckboxText += ' checkbox-input-text-disabled';
  }

  return (
    <div className="relative checkbox-wrapper">
      <label
        htmlFor={id}
        className={classnames(defaultLabelClassName, labelClassName)}
      >
        <Checkbox
          id={id}
          value={value}
          onChange={onChange}
          ref={ref}
          name={name}
          isControlled={isControlled}
          {...inputProps}
        />

        <span className={defaultCheckboxText}>{Children.toArray(label)}</span>
      </label>
    </div>
  );
});

CheckboxInput.defaultProps = {
  labelClassName: '',
};

export default CheckboxInput;
